import type { PartidaView } from "./tipos";

/**
 * As cores dos botões no campo: as mesmas em toda partida.
 *
 * Eram as do escudo de cada clube, e dois times de camisa vermelha viravam uma
 * mancha só: quem jogava não sabia quem era quem. Agora o seu time é sempre
 * azul, o adversário sempre vermelho, e os dois goleiros amarelos, com a borda
 * na cor do time. Numa partida sem o seu clube, o mandante fica com o azul.
 */

export interface CorDoBotao {
  fundo: string;
  borda: string;
  texto: string;
}

const AZUL: CorDoBotao = { fundo: "#2f7cf6", borda: "#d6e6ff", texto: "#ffffff" };
const VERMELHO: CorDoBotao = { fundo: "#e5484d", borda: "#ffe0e1", texto: "#ffffff" };
const AMARELO = { fundo: "#f5c542", texto: "#1a1200" };

type Lado = "home" | "away";

/** O lado que joga de azul: o do seu clube, ou o mandante quando o seu não está em campo. */
function ladoAzul(partida: PartidaView): Lado {
  if (partida.myClubId === partida.away.clubId) return "away";
  return "home";
}

/** A cor dos jogadores de linha de um lado. */
export function corDoTime(partida: PartidaView, lado: Lado): CorDoBotao {
  return lado === ladoAzul(partida) ? AZUL : VERMELHO;
}

/** A cor de um botão: goleiro amarelo com a borda do time, o resto na cor do time. */
export function corDoBotao(partida: PartidaView, lado: Lado, goleiro: boolean): CorDoBotao {
  const time = corDoTime(partida, lado);
  return goleiro ? { fundo: AMARELO.fundo, borda: time.fundo, texto: AMARELO.texto } : time;
}
